import React from 'react';
import "../components/Work.css";

function Work() {
  return (
    <div className='work'>
      <h2>How do we work?</h2>
      <div className='workContent'>
        <div className='cards'>
          <div className='card'>
            <div className='title'>
              <h1>01</h1>
              <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59" fill="none">
                <rect width="48" height="48" fill="#D9D9D9" />
                <rect x="11" y="11" width="48" height="48" rx="24" fill="#454545" />
              </svg>
            </div>
            <h2>Initial Consultation</h2>
            <p>Let's begin with an introduction call to understand your project requirements.<br/><br/>We'll discuss how we can assist you in achieving your goals within your specified budget and timeline.</p>
          </div>
          <div className='card'>
            <div className='title'>
              <h1>02</h1>
              <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59" fill="none">
                <path d="M48 48H24C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24V48Z" fill="#D9D9D9" />
                <path d="M59 59L11 59V35C11 21.7452 21.7452 11 35 11C48.2548 11 59 21.7452 59 35V59Z" fill="#454545" />
              </svg>
            </div>
            <h2>Project Briefing</h2>
            <p>Following our initial call, we'll delve deeper into your project during a comprehensive briefing.<br/><br/> This step ensures a thorough understanding of your requirements and sets the foundation for a successful collaboration.</p>
          </div>
          <div className='card'>
            <div className='title'>
              <h1>03</h1>
              <svg xmlns="http://www.w3.org/2000/svg" width="63" height="74" viewBox="0 0 63 74" fill="none">
                <path d="M48 48L0 48L0 0L48 0L48 48Z" fill="#D9D9D9" />
                <path d="M35 11L59.2487 58.25H10.7513L35 11Z" fill="#454545" />
              </svg>
            </div>
            <h2>Contract Signing</h2>
            <p>Upon finalizing project details, we proceed to the contract signing phase. <br/><br/>Our transparent and straightforward contracts ensure a clear understanding of deliverables, timelines, and terms, fostering a strong client-vendor relationship.</p>
          </div>
          <div className='card'>
            <div className='title'>
              <h1>04</h1>
              <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59" fill="none">
                <path d="M48 48L0 48V24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V48Z" fill="#D9D9D9" />
                <path d="M59 35C59 48.2548 48.2548 59 35 59V59C21.7452 59 11 48.2548 11 35V35C11 21.7452 21.7452 11 35 11V11C48.2548 11 59 21.7452 59 35V35Z" fill="#454545" />
              </svg>
            </div>
            <h2>Team Introduction</h2>
            <p>Once the formalities are complete, you'll be introduced to your dedicated outsourcing team. <br/><br/>This step allows you to familiarize yourself with the professionals who will be working closely with you to bring your project to fruition.</p>
          </div>
          <div className='card'>
            <div className='title'>
              <h1>05</h1>
              <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59" fill="none">
                <path d="M48 48H24C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24V48Z" fill="#D9D9D9" />
                <path d="M59 59L11 59V35C11 21.7452 21.7452 11 35 11C48.2548 11 59 21.7452 59 35V59Z" fill="#454545" />
              </svg>
            </div>
            <h2>Collaborative Work</h2>
            <p>With the formalities complete and the team in place, we embark on a collaborative journey to bring your project to life. <br/><br/>Regular communication and progress updates ensure that your project is on track, meeting your expectations and objectives.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Work;
